module.exports = __webpack_public_path__ + "static/media/environmental.0698a203.png";